const getNotificationOptions = (intl) => [
  {
    value: "personal",
    label: intl.formatMessage({
      id: "settings.notifications.personalNotificationsOnly",
      defaultMessage: "Personal notifications only",
    }),
  },
  {
    value: "team",
    label: intl.formatMessage({
      id: "settings.notifications.personalAndTeamNotifications",
      defaultMessage: "Personal & team notifications",
    }),
  },
  {
    value: "off",
    label: intl.formatMessage({
      id: "settings.notifications.off",
      defaultMessage: "Off",
    }),
  },
  {
    value: "custom",
    label: intl.formatMessage({
      id: "settings.notifications.customSettings",
      defaultMessage: "Custom settings",
    }),
  },
];

const getRadioOptions = (intl) => [
  {
    value: "personal",
    label: intl.formatMessage({
      id: "settings.notifications.personalOnly",
      defaultMessage: "Personal only",
    }),
  },
  {
    value: "team",
    label: intl.formatMessage({
      id: "settings.notifications.teamNotifications",
      defaultMessage: "Team notifications",
    }),
  },
  {
    value: "off",
    label: intl.formatMessage({
      id: "settings.notifications.notificationsOff",
      defaultMessage: "Notifications off",
    }),
  },
];

const getRateManagementCustomDefaultOptions = (intl) => [
  {
    key: "provider_submit_bids",
    label: intl.formatMessage({
      id: "settings.notifications.rate-management.bidReceived",
      defaultMessage: "Bid received",
    }),
    value: "personal",
  },
  {
    key: "tender_bid_deadline_passed",
    label: intl.formatMessage({
      id: "settings.notifications.rate-management.bidDeadlinePassed",
      defaultMessage: "Bid deadline passed",
    }),
    value: "personal",
  },
  {
    key: "tender_comment",
    label: intl.formatMessage({
      id: "settings.notifications.rate-management.tenderComment",
      defaultMessage: "Tender comment",
    }),
    value: "personal",
  },
  {
    key: "tender_confirmation_date_passed",
    label: intl.formatMessage({
      id: "settings.notifications.rate-management.tenderConfirmationDate",
      defaultMessage: "Tender confirmation date",
    }),
    value: "personal",
  },
];

const getBillingNotificationCustomDefaultOptions = (intl) => [
  {
    key: "invoice_audit_reminder",
    label: intl.formatMessage({
      id: "settings.notifications.billing.invoiceAuditReminder",
      defaultMessage: "Invoice audit reminder",
    }),
    value: "personal",
  },
  {
    key: "invoice_audit_requested",
    label: intl.formatMessage({
      id: "settings.notifications.billing.invoiceAuditRequested",
      defaultMessage: "Invoice audit requested",
    }),
    value: "personal",
  },
  {
    key: "invoice_payment_requested",
    label: intl.formatMessage({
      id: "settings.notifications.billing.invoicePaymentRequested",
      defaultMessage: "Invoice payment requested",
    }),
    value: "personal",
  },
  {
    key: "provider_cancels_invoice",
    label: intl.formatMessage({
      id: "settings.notifications.rate-management.providerCancelsInvoice",
      defaultMessage: "Provider cancels invoice",
    }),
    value: "personal",
  },
  {
    key: "provider_posts_comment_on_invoice",
    label: intl.formatMessage({
      id: "settings.notifications.billing.providerPostsCommentOnInvoice",
      defaultMessage: "Provider posts comment on invoice",
    }),
    value: "personal",
  },
];

const getMobileNotificationCustomDefaultOptions = (intl) => [
  {
    key: "mobile_requested_approval",
    label: intl.formatMessage({
      id: "settings.notifications.mobile.approvalRequest",
      defaultMessage: "Approval request",
    }),
    value: "personal",
  },
  {
    key: "mobile_shipper_shipment_booked",
    label: intl.formatMessage({
      id: "settings.notifications.mobile.shipmentIsBooked",
      defaultMessage: "Shipment is booked",
    }),
    value: "personal",
  },
  {
    key: "mobile_shipper_shipment_poded",
    label: intl.formatMessage({
      id: "settings.notifications.mobile.shipmentIsDelivered",
      defaultMessage: "Shipment is delivered (POD)",
    }),
    value: "personal",
  },
  {
    key: "mobile_shipper_shipment_updated",
    label: intl.formatMessage({
      id: "settings.notifications.mobile.shipmentIsUpdated",
      defaultMessage: "Shipment is updated",
    }),
    value: "personal",
  },
];

const getShipmentNotificationCustomDefaultOptions = (intl) => [
  {
    key: "additional_cost_added",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.additionalCostAdded",
      defaultMessage: "Additional cost added",
    }),
    value: "personal",
  },
  {
    key: "automated_tracking_event",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.automatedTrackingEvent",
      defaultMessage: "Automated tracking event",
    }),
    value: "personal",
  },
  {
    key: "discount_item_added",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.discountItemAdded",
      defaultMessage: "Discount item added",
    }),
    value: "personal",
  },
  {
    key: "provider_edits_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.providerEditsShipment",
      defaultMessage: "Provider edits shipment",
    }),
    value: "personal",
  },
  {
    key: "provider_posts_document",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.providerPostsDocument",
      defaultMessage: "Provider posts document",
    }),
    value: "personal",
  },
  {
    key: "provider_posts_update",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.providerPostsUpdate",
      defaultMessage: "Provider posts update",
    }),
    value: "personal",
  },
  {
    key: "provider_submits_delayed_pod",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.providerSubmitsDelayedPod",
      defaultMessage: "Provider submits delayed POD",
    }),
    value: "personal",
  },
  {
    key: "provider_submits_pod",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.providerSubmitsPod",
      defaultMessage: "Provider submits POD",
    }),
    value: "personal",
  },
  {
    key: "provider_submits_pop",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsPOP",
      defaultMessage: "Provider submits POP",
    }),
    value: "personal",
  },
  {
    key: "provider_submits_pop_and_pod",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsPOPAndPOD",
      defaultMessage: "Provider submits POP and POD",
    }),
    value: "personal",
  },
  {
    key: "provider_submits_delayed_pop_and_pod",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsDelayedPOPAndPOD",
      defaultMessage: "Provider submits POP and Delayed POD",
    }),
    value: "personal",
  },
  {
    key: "provider_wins_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.shipmentBooked",
      defaultMessage: "A shipment is booked",
    }),
    value: "personal",
  },
  {
    key: "quotation_is_extended",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.quotationIsExtended",
      defaultMessage: "Quotation is extended",
    }),
    value: "personal",
  },
  {
    key: "shipment_auto_closed",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.shipmentAutoClosure",
      defaultMessage: "Shipment auto closure",
    }),
    value: "personal",
  },
  {
    key: "shipment_exception_received",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.shipmentExceptionReceived",
      defaultMessage: "Shipment exception received",
    }),
    value: "personal",
  },
  {
    key: "shipment_is_delayed",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.shipmentIsDelayed",
      defaultMessage: "Shipment is delayed",
    }),
    value: "personal",
  },
  {
    key: "shipper_posts_document",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.shipperPostsDocument",
      defaultMessage: "Shipper posts document",
    }),
    value: "personal",
  },
  {
    key: "shipper_posts_update",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.shipperPostsUpdate",
      defaultMessage: "Shipper posts update",
    }),
    value: "personal",
  },
  {
    key: "shipper_portcast_container_tracking_updates_notifications",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.shipperOceanTrackingUpdates",
      defaultMessage: "Ocean Tracking updates",
    }),
    value: "personal",
  },
  {
    key: "ocean_tracking_arrival_reminder_before_48_hours",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.shipperOceanTrackingArrivalReminderBefore48Hours",
      defaultMessage: "Ocean tracking arrival reminder (48h)",
    }),
    value: "personal",
  },
  {
    key: "shipper_portcast_air_tracking_updates_notifications",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.airTrackingUpdates",
      defaultMessage: "Air Tracking updates",
    }),
    value: "personal",
  },
  {
    key: "pre_pickup_and_delivery_updates",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.prePickupDeliveryUpdates",
      defaultMessage: "Pre-pickup and delivery updates",
    }),
    value: "personal",
  },
];

const getRequestNotificationCustomDefaultOptions = (intl) => [
  {
    key: "approval_reminder",
    label: intl.formatMessage({
      id: "settings.notifications.request.approvalReminder",
      defaultMessage: "Approval reminder",
    }),
    value: "personal",
  },
  {
    key: "new_parcel_quotes",
    label: intl.formatMessage({
      id: "settings.notifications.request.newParcelQuotes",
      defaultMessage: "New parcel quotes",
    }),
    value: "personal",
  },
  {
    key: "provider_cancels_a_quote",
    label: intl.formatMessage({
      id: "settings.notifications.request.providerCancelsQuote",
      defaultMessage: "Provider cancels a quote",
    }),
    value: "personal",
  },
  {
    key: "provider_changes_a_quote",
    label: intl.formatMessage({
      id: "settings.notifications.request.providerChangesQuote",
      defaultMessage: "Provider changes a quote",
    }),
    value: "personal",
  },
  {
    key: "provider_confirms_quote",
    label: intl.formatMessage({
      id: "settings.notifications.request.providerConfirmsQuote",
      defaultMessage: "Provider confirms quote",
    }),
    value: "personal",
  },
  {
    key: "provider_declines_to_quote",
    label: intl.formatMessage({
      id: "settings.notifications.request.providerDeclinesToQuote",
      defaultMessage: "Provider declines to quote",
    }),
    value: "personal",
  },
  {
    key: "provider_posts_a_comment",
    label: intl.formatMessage({
      id: "settings.notifications.request.providerPostsComment",
      defaultMessage: "Provider posts a comment",
    }),
    value: "personal",
  },
  {
    key: "provider_submits_a_quote",
    label: intl.formatMessage({
      id: "settings.notifications.request.providerSubmitsQuote",
      defaultMessage: "Provider submits a quote",
    }),
    value: "personal",
  },
  {
    key: "provider_undoes_decline",
    label: intl.formatMessage({
      id: "settings.notifications.request.providerUndoesDecline",
      defaultMessage: "Provider undoes decline",
    }),
    value: "personal",
  },
  {
    key: "quick_request_is_canceled",
    label: intl.formatMessage({
      id: "settings.notifications.request.quickRequestIsCanceled",
      defaultMessage: "Quick request is canceled",
    }),
    value: "personal",
  },
  {
    key: "quick_request_is_converted",
    label: intl.formatMessage({
      id: "settings.notifications.request.quickRequestConverted",
      defaultMessage: "Quick request is converted",
    }),
    value: "personal",
  },
  {
    key: "quick_request_is_created",
    label: intl.formatMessage({
      id: "settings.notifications.request.quickRequestIsCreated",
      defaultMessage: "Quick request is created",
    }),
    value: "personal",
  },
  {
    key: "quick_request_leads_to_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.request.quickRequestLeadsToShipment",
      defaultMessage: "Quick Request leads to shipment",
    }),
    value: "personal",
  },
  {
    key: "quotation_timer_has_ended",
    label: intl.formatMessage({
      id: "settings.notifications.request.quotationTimerEnded",
      defaultMessage: "Quotation timer has ended",
    }),
    value: "personal",
  },
  {
    key: "shipper_cancels_approval_request",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperCancelsApprovalRequest",
      defaultMessage: "Shipper cancels approval request",
    }),
    value: "personal",
  },
  {
    key: "shipper_cancels_quote_request",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperCancelsQuoteRequest",
      defaultMessage: "Shipper cancels quote request",
    }),
    value: "personal",
  },
  {
    key: "shipper_declines_approval",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperDeclinesApproval",
      defaultMessage: "Shipper declines approval",
    }),
    value: "personal",
  },
  {
    key: "shipper_is_asked_to_confirm",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperAskedToConfirm",
      defaultMessage: "Shipper is asked to confirm",
    }),
    value: "personal",
  },
  {
    key: "shipper_is_warned_for_auto-cancelation",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperWarnedMsg",
      defaultMessage: "Shipper is warned for auto-cancelation",
    }),
    value: "personal",
  },
  {
    key: "shipper_posts_quick_request_comment",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperPostsQuickRequestComment",
      defaultMessage: "Shipper posts quick request comment",
    }),
    value: "personal",
  },
  {
    key: "shipper_requests_approval",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperRequestsApproval",
      defaultMessage: "Shipper requests approval",
    }),
    value: "personal",
  },
  {
    key: "shipper_should_confirm_2_hrs",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperShouldConfirmTwoHour",
      defaultMessage: "Shipper should confirm < 2 hours",
    }),
    value: "personal",
  },
  {
    key: "shipper_should_confirm_5_minutes",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperShouldConfirmFiveMinute",
      defaultMessage: "Shipper should confirm < 5 minutes",
    }),
    value: "personal",
  },
  {
    key: "shipper_submits_new_quote_request",
    label: intl.formatMessage({
      id: "settings.notifications.request.shipperSubmitsNewQuoteRequest",
      defaultMessage: "Shipper submits new quote request",
    }),
    value: "personal",
  },
  {
    key: "quote_request_approval_email",
    label: intl.formatMessage({
      id: "settings.notifications.shipment.approvalViaEmail",
      defaultMessage: "Approval through email",
    }),
    value: "personal",
  },
];

export {
  getNotificationOptions,
  getRadioOptions,
  getRateManagementCustomDefaultOptions,
  getBillingNotificationCustomDefaultOptions,
  getMobileNotificationCustomDefaultOptions,
  getShipmentNotificationCustomDefaultOptions,
  getRequestNotificationCustomDefaultOptions,
};
